(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {
  let clearing = false;

  document.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-cart-drawer-clear]");
    if (!button) return;
    event.preventDefault();
    if (clearing) return;

    const drawer = button.closest('[data-section-modification="drawer"]');
    const error = drawer.querySelector("[data-cart-drawer-clear-error]");
    const label = button.textContent;
    clearing = true;
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    button.textContent = button.dataset.loadingText;
    error.hidden = true;

    try {
      const sectionIds = [...new Set(
        [...document.querySelectorAll('[data-section-type="cart-template"]')]
          .map((section) => section.dataset.sectionId)
          .filter(Boolean)
      )];
      const { CartApi, EventBus } = window.themeCore;
      const cart = await CartApi.makeRequest(
        CartApi.actions.CLEAR_CART,
        sectionIds.join(","),
        { noOpen: true }
      );
      if (!cart.sections || sectionIds.some((id) => !cart.sections[id])) {
        cart.sections = {};
      }
      EventBus.emit("cart:drawer:close");
    } catch {
      error.hidden = false;
    } finally {
      clearing = false;
      button.disabled = false;
      button.removeAttribute("aria-busy");
      button.textContent = label;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["richtext"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktop = window.matchMedia('(min-width: 1200px)');
    const entries = new Map();
    const structuredDescriptions = new Map();
    // Let tall columns scroll naturally before their bottom stays in view.
    // Observe content size so accordions, images and fonts cannot clip the column.
    let stickyMedia = null;
    let stickyTop = 24;
    let previousScrollY = window.scrollY;
    function stickyBounds() {
      const header = document.querySelector('.js-header');
      const upper = 24 + (header ? header.getBoundingClientRect().height : 0);
      return { upper, lower: Math.min(upper, window.innerHeight - stickyMedia.getBoundingClientRect().height - 24) };
    }
    function setStickyTop(value) {
      stickyTop = value;
      stickyMedia.style.setProperty('--ww-column-top', Math.floor(value) + 'px');
    }
    function measureStickyColumn() {
      if (!stickyMedia || !desktop.matches) return;
      const bounds = stickyBounds();
      // Preserve the current position when a panel expands; scrolling then reveals the rest.
      setStickyTop(Math.max(bounds.lower, Math.min(bounds.upper, stickyMedia.getBoundingClientRect().top)));
      previousScrollY = window.scrollY;
    }
    const columnObserver = typeof ResizeObserver === 'function'
      ? new ResizeObserver(measureStickyColumn) : null;
    function syncStickyColumn() {
      const media = desktop.matches ? document.querySelector('.product-media.ww-description-column') : null;
      if (stickyMedia !== media) {
        if (stickyMedia) stickyMedia.style.removeProperty('--ww-column-top');
        columnObserver?.disconnect();
        stickyMedia = media;
        if (media) columnObserver?.observe(media);
      }
      measureStickyColumn();
    }
    window.addEventListener('scroll', () => {
      const delta = window.scrollY - previousScrollY;
      previousScrollY = window.scrollY;
      if (!stickyMedia || !desktop.matches || !delta) return;
      const bounds = stickyBounds();
      setStickyTop(Math.max(bounds.lower, Math.min(bounds.upper, stickyTop - delta)));
    }, { passive: true });
    window.addEventListener('resize', measureStickyColumn);
    document.addEventListener('toggle', event => {
      if (stickyMedia?.contains(event.target)) measureStickyColumn();
    }, true);
    document.addEventListener('load', event => {
      if (stickyMedia?.contains(event.target)) measureStickyColumn();
    }, true);
    function structureDescription(description) {
      const content = description?.querySelector('.text-section__content');
      if (!content || structuredDescriptions.has(content)) return;
      const original = Array.from(content.childNodes);
      // Some imported descriptions use standalone bold paragraphs instead of H2–H6.
      // Keep full paragraphs and mixed emphasis as body text.
      const headingText = node => node.textContent.replace(/\s+/g, ' ').trim();
      const isDescriptionHeading = node => {
        if (node.querySelector('a, button, input, img, video, iframe')) return false;
        if (/^H[2-6]$/.test(node.tagName)) return true;
        if (node.tagName !== 'P') return false;
        const text = headingText(node);
        if (!text || text.length > 120 || text.split(' ').length > 14 || /[.!?;]$/.test(text)) return false;
        const bold = Array.from(node.querySelectorAll('strong, b')).filter(el => !el.parentElement.closest('strong, b'));
        return bold.length > 0 && bold.map(headingText).join(' ').replace(/\s+/g, ' ').trim() === text;
      };
      const headings = Array.from(content.children).filter(isDescriptionHeading);
      const firstParagraph = Array.from(content.children).find(node => node.tagName === 'P' && node.textContent.trim());
      if (!firstParagraph && !headings.length) return;
      // Real H2–H6 headings define separate sections; bold paragraphs only receive typography.
      const sectionHeadings = headings.filter(node => /^H[2-6]$/.test(node.tagName));
      if (sectionHeadings.length) {
        const panels = [];
        function panel(label, children, isHeading) {
          if (!children.some(node => node.nodeType === 1 || node.textContent.trim())) return;
          const details = document.createElement('details');
          details.className = 'ww-info-disclosure';
          const summary = document.createElement('summary');
          const body = document.createElement('div');
          body.className = 'ww-info-disclosure__content';
          const anchor = isHeading ? label : children[0];
          anchor.before(details);
          if (isHeading) summary.append(label);
          else summary.textContent = label;
          body.append(...children);
          details.append(summary, body);
          if (!isHeading || body.textContent.trim().length < 500) details.open = true;
          panels.push(details);
        }
        if (firstParagraph && (!sectionHeadings.length || original.indexOf(firstParagraph) < original.indexOf(sectionHeadings[0]))) {
          const start = original.indexOf(firstParagraph) + 1;
          const nextHeading = sectionHeadings.find(node => original.indexOf(node) >= start);
          const end = nextHeading ? original.indexOf(nextHeading) : original.length;
          const rest = original.slice(start, end);
          if (rest.reduce((count, node) => count + node.textContent.trim().length, 0) > 240) {
            panel(description.dataset.moreLabel, rest, false);
          }
        }
        sectionHeadings.forEach((heading, index) => {
          const start = original.indexOf(heading) + 1;
          const end = index + 1 < sectionHeadings.length ? original.indexOf(sectionHeadings[index + 1]) : original.length;
          panel(heading, original.slice(start, end), true);
        });
        if (panels.length) structuredDescriptions.set(content, { original, panels, formattedHeadings: [], spacers: [] });
        return;
      }
      const formattedHeadings = headings.filter(node => !node.classList.contains('ww-description-subheading'));
      formattedHeadings.forEach(node => node.classList.add('ww-description-subheading'));
      const spacers = original.filter(node => node.nodeType === 1 && node.tagName === 'P' &&
        !node.textContent.trim() && !node.querySelector(':not(br)') && !node.classList.contains('ww-description-spacer'));
      spacers.forEach(node => node.classList.add('ww-description-spacer'));
      const panels = [];
      // Keep the introduction outside one open disclosure; headings remain in the text.
      const intro = firstParagraph && !headings.includes(firstParagraph) &&
        (!headings.length || original.indexOf(firstParagraph) < original.indexOf(headings[0]));
      const start = intro ? original.indexOf(firstParagraph) + 1 : 0;
      const rest = original.slice(start);
      const remainingText = rest.reduce((count, node) => count + node.textContent.trim().length, 0);
      if (rest.length && (headings.length || remainingText > 240)) {
        const details = document.createElement('details');
        details.className = 'ww-info-disclosure ww-description-continuous';
        details.open = true;
        const summary = document.createElement('summary');
        summary.textContent = description.dataset.moreLabel;
        const body = document.createElement('div');
        body.className = 'ww-info-disclosure__content';
        rest[0].before(details);
        body.append(...rest);
        details.append(summary, body);
        panels.push(details);
      }
      if (panels.length || formattedHeadings.length || spacers.length) structuredDescriptions.set(content, { original, panels, formattedHeadings, spacers });
    }
    function unstructureDescription(description) {
      const content = description?.querySelector('.text-section__content');
      const saved = structuredDescriptions.get(content);
      if (!saved) return;
      content.append(...saved.original);
      saved.panels.forEach(panel => panel.remove());
      saved.formattedHeadings.forEach(node => node.classList.remove('ww-description-subheading'));
      saved.spacers.forEach(node => node.classList.remove('ww-description-spacer'));
      structuredDescriptions.delete(content);
    }
    const printPanels = new Set();
    window.addEventListener('beforeprint', () => {
      document.querySelectorAll('.ww-description-column details:not([open]), main:has(.ww-flow-product) [data-product-description] details:not([open]), main:has(.ww-flow-product) .download_sheet_container details:not([open])').forEach(panel => {
        printPanels.add(panel);
        panel.open = true;
      });
    });
    window.addEventListener('afterprint', () => {
      printPanels.forEach(panel => { panel.open = false; });
      printPanels.clear();
    });


    function restore(entry) {
      if (entry.marker.isConnected) entry.marker.after(entry.wrapper);
      if (entry.media) entry.media.classList.remove('ww-description-column');
      entry.wrapper.classList.remove('ww-left-info-section');
      const description = entry.wrapper.querySelector('[data-product-description]');
      unstructureDescription(description);
      const button = description?.querySelector('.js-rich-text-read-more');
      const content = description?.querySelector('.text-section__content');
      if (button && content) {
        content.classList.toggle('text-section__content--cut-off', button.getAttribute('aria-expanded') !== 'true');
      }
      entry.media = null;
    }

    function register(wrapper, ownerId) {
      if (!wrapper || entries.has(wrapper.id)) return;
      const marker = document.createComment('');
      wrapper.before(marker);
      entries.set(wrapper.id, { wrapper, marker, media: null, ownerId });
    }

    function refresh() {
      const flowMode = Boolean(document.querySelector('.ww-flow-product'));
      document.querySelectorAll('[data-product-description]').forEach((description) => {
        const wrapper = description.closest('.shopify-section');
        if (!wrapper || flowMode) return;
        register(wrapper, wrapper.id);
        const prefix = wrapper.id.slice(0, wrapper.id.lastIndexOf('__') + 2);
        (description.dataset.desktopSectionIds || '').split(',').forEach((id) => {
          const suffix = id.trim();
          if (suffix) register(document.getElementById(prefix + suffix), wrapper.id);
        });
      });

      const media = document.querySelector('section.product[data-section-type="product"] > .product-media');
      entries.forEach((entry, id) => {
        if (!entry.marker.isConnected) {
          if (entry.media) entry.wrapper.remove();
          entries.delete(id);
          return;
        }
        if (!flowMode && desktop.matches && media && !window.Shopify?.designMode) {
          if (entry.media && entry.media !== media) restore(entry);
          if (entry.wrapper.parentElement !== media) media.append(entry.wrapper);
          entry.wrapper.classList.add('ww-left-info-section');
          entry.wrapper.querySelector('[data-product-description] .text-section__content')?.classList.remove('text-section__content--cut-off');
          structureDescription(entry.wrapper.querySelector('[data-product-description]'));
          media.classList.add('ww-description-column');
          entry.media = media;
        } else if (!flowMode || entry.media) {
          restore(entry);
        }
      });
      if (flowMode) {
        document.querySelectorAll('[data-product-description]').forEach(description => {
          description.querySelector('.text-section__content')?.classList.remove('text-section__content--cut-off');
          structureDescription(description);
        });
      }
      syncStickyColumn();
    }

    desktop.addEventListener('change', refresh);
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('shopify:section:reorder', refresh);
    document.addEventListener('shopify:section:unload', (event) => {
      entries.forEach((entry, id) => {
        if (event.target === entry.wrapper || event.target.id === entry.ownerId) {
          restore(entry);
          entry.marker.remove();
          entries.delete(id);
        } else if (entry.media && event.target.contains(entry.media)) {
          restore(entry);
        }
      });
      syncStickyColumn();
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refresh, { once: true });
    } else {
      refresh();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
